import { Link } from 'react-router-dom';
import Layout from '@/components/feature/Layout';
import JsonLd from '@/components/base/JsonLd';

const values = [
  {
    icon: 'ri-heart-3-fill',
    title: '热爱为先',
    desc: '一切内容围绕真实热爱展开，尊重每一位同好的追番与安利。',
  },
  {
    icon: 'ri-message-3-fill',
    title: '友善交流',
    desc: '倡导理性、友善的讨论氛围，让每一次交流都有温度。',
  },
  {
    icon: 'ri-compass-3-fill',
    title: '开放多元',
    desc: '欢迎不同口味、不同观点的同好，百花齐放才是圈子的魅力。',
  },
  {
    icon: 'ri-sparkling-fill',
    title: '持续成长',
    desc: '与社区一起进化，不断打磨内容，让好作品被更多人看见。',
  },
];

const testimonials = [
  {
    name: '栗子同学',
    role: '追更三年',
    text: '在这里找到了太多同好，讨论氛围很舒服，遇到不懂的剧情大家都会耐心解答。',
  },
  {
    name: '阿叶',
    role: '安利狂魔',
    text: '每次发帖安利冷门番都有人认真回复，能碰到愿意一起追更的朋友真的太难得了。',
  },
  {
    name: '小满',
    role: '潜水党',
    text: '虽然很少发言，但每天都会来看大家讨论，像回家一样温暖。',
  },
];

export default function About() {
  return (
    <Layout>
      <JsonLd
        data={{
          '@context': 'https://schema.org',
          '@type': 'AboutPage',
          name: '关于羞羞动漫社',
          description: '了解羞羞动漫社的品牌介绍、发展理念、内容原则与社区口碑。',
          url: 'https://mangafor.github.io/about',
          about: {
            '@type': 'Organization',
            name: '羞羞动漫社',
            description: '面向动漫漫画同好群体的中文讨论交流社区',
          },
        }}
      />

      <section className="relative overflow-hidden bg-foreground-900 pt-24 md:pt-28 pb-12 md:pb-16 text-center">
        <div className="relative z-10 mx-auto w-full max-w-7xl px-4 md:px-6">
          <h1 className="font-heading text-3xl md:text-5xl text-background-50">关于羞羞动漫社</h1>
          <p className="mx-auto mt-3 max-w-xl text-sm md:text-base text-background-100/90">
            一个由热爱驱动的动漫漫画同好讨论交流社区。
          </p>
        </div>
      </section>

      <section className="mx-auto w-full max-w-5xl px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:items-center">
          <div>
            <span className="text-xs font-semibold tracking-widest text-primary-600">BRAND STORY</span>
            <h2 className="mt-2 font-heading text-2xl md:text-3xl">我们是谁</h2>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-700">
              羞羞动漫社最初只是几个动漫爱好者在聊天时随口提起的小想法——想要一个能一起讨论剧情、安利心头好、分享追番心得的安静角落。
            </p>
            <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-700">
              如今它成长为面向所有动漫漫画同好的中文讨论交流社区。我们相信，热爱是连接彼此最直接的语言，而好的讨论能让一部作品被看见、被理解、被记住。
            </p>
          </div>
          <div className="rounded-2xl border border-background-200 bg-background-50 p-6 md:p-8">
            <h3 className="text-sm font-bold text-foreground-950">我们的定位</h3>
            <p className="mt-3 text-sm leading-relaxed text-foreground-700">
              做一个「找得到同好、聊得起话题、读得到深度」的动漫漫画社区。
            </p>
            <ul className="mt-4 space-y-3 text-sm text-foreground-700">
              <li className="flex gap-2"><i className="ri-check-double-line text-primary-600"></i>按兴趣划分板块，让讨论更有组织</li>
              <li className="flex gap-2"><i className="ri-check-double-line text-primary-600"></i>持续产出新番速递与深度专题</li>
              <li className="flex gap-2"><i className="ri-check-double-line text-primary-600"></i>倡导友善理性，守护温暖的交流氛围</li>
            </ul>
          </div>
        </div>

        <div className="mt-14">
          <div className="text-center">
            <span className="text-xs font-semibold tracking-widest text-primary-600">OUR VALUES</span>
            <h2 className="mt-2 font-heading text-2xl md:text-3xl">我们的理念</h2>
          </div>
          <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {values.map((v) => (
              <div key={v.title} className="rounded-2xl border border-background-200 bg-background-50 p-5 hover:border-primary-300 transition-colors">
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary-100 text-primary-700">
                  <i className={`${v.icon} text-xl`}></i>
                </span>
                <h3 className="mt-4 text-base font-bold text-foreground-950">{v.title}</h3>
                <p className="mt-2 text-xs md:text-sm leading-relaxed text-foreground-600">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-14">
          <div className="text-center">
            <span className="text-xs font-semibold tracking-widest text-primary-600">TESTIMONIALS</span>
            <h2 className="mt-2 font-heading text-2xl md:text-3xl">同好的声音</h2>
          </div>
          <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-3">
            {testimonials.map((t) => (
              <figure key={t.name} className="rounded-2xl border border-background-200 bg-background-50 p-5">
                <div className="flex text-accent-500 gap-0.5">
                  {[0, 1, 2, 3, 4].map((i) => (
                    <i key={i} className="ri-star-fill"></i>
                  ))}
                </div>
                <blockquote className="mt-3 text-sm leading-relaxed text-foreground-700">“{t.text}”</blockquote>
                <figcaption className="mt-4 flex items-center gap-3">
                  <span className="flex h-9 w-9 items-center justify-center rounded-full bg-accent-100 font-heading text-accent-700">
                    {t.name.slice(0, 1)}
                  </span>
                  <div>
                    <p className="text-sm font-semibold text-foreground-950">{t.name}</p>
                    <p className="text-xs text-foreground-500">{t.role}</p>
                  </div>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>

        <div className="mt-14 rounded-2xl bg-primary-500 p-6 md:p-10 text-center text-background-50">
          <h2 className="font-heading text-xl md:text-2xl">想加入我们吗？</h2>
          <p className="mx-auto mt-2 max-w-lg text-sm text-background-100/90">
            无论是参与讨论、安利作品，还是有任何建议，都欢迎你随时加入羞羞动漫社。
          </p>
          <div className="mt-5 flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/community"
              className="inline-flex whitespace-nowrap items-center gap-1.5 rounded-lg bg-background-50 px-5 py-2.5 text-sm font-semibold text-primary-700 hover:bg-background-100 transition-colors"
            >
              进入社区 <i className="ri-arrow-right-line"></i>
            </Link>
            <Link
              to="/contact"
              className="inline-flex whitespace-nowrap items-center gap-1.5 rounded-lg bg-primary-600 px-5 py-2.5 text-sm font-semibold text-background-50 hover:bg-primary-700 transition-colors"
            >
              联系我们
            </Link>
          </div>
        </div>
      </section>
    </Layout>
  );
}